import { seo } from '../seo';
export { StaticHostingPlanPage as default } from '../../src/pages/Product/StaticHostingPlanPage';
export const meta = () => seo('hosting.static');
